/**
 * Japanese translations
 */
import { common } from './ja/common';
import { dashboard } from './ja/dashboard';
import { vision2040 } from './ja/vision2040';
import { mentalHealth } from './ja/mentalHealth';
import { members } from './ja/members';
import { programs } from './ja/programs';
import { technology } from './ja/technology';
import { regional } from './ja/regional';
import { impact } from './ja/impact';
import { workforce } from './ja/workforce';
import { entrepreneurship } from './ja/entrepreneurship';
import { contributing } from './ja/contributing';
import { faq } from './ja/faq';
import { methodology } from './ja/methodology';
import { developmentCouncils } from './ja/developmentCouncils';
import { privacy } from './ja/privacy';
import { terms } from './ja/terms';
import { countryProfile } from './ja/countryProfile';

// NOTE: both Programs & Events and Technology modules used the same root key "programs".
// We deep-merge here to prevent one module from overwriting the other.
const { programs: programsLabels, ...programsRest } = programs;
const { programs: technologyProgramLabels, ...technologyRest } = technology;

export const ja = {
  ...common,
  ...dashboard,
  ...mentalHealth,
  ...regional,
  ...members,
  ...programsRest,
  ...impact,
  ...technologyRest,
  ...vision2040,
  ...workforce,
  ...entrepreneurship,
  ...contributing,
  ...methodology,
  ...developmentCouncils,
  ...countryProfile,
  privacy,
  terms,
  faq,
  programs: {
    ...programsLabels,
    ...technologyProgramLabels,
  },
} as const;

export type JaTranslations = typeof ja;

